import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7af7a016"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "trip-container column"
}
const _hoisted_2 = { class: "col" }
const _hoisted_3 = { class: "col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.distance)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createTextVNode("Distancia:"),
          _createElementVNode("strong", null, _toDisplayString($setup.distance) + " kms", 1)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createTextVNode("Duración:"),
          _createElementVNode("strong", null, _toDisplayString($setup.duration) + " minutos", 1)
        ])
      ]))
    : _createCommentVNode("", true)
}